import React from 'react';
import { SettingsTeamCard } from './SettingsTeamCard';

export const SettingsTeamSection: React.FC = () => {
  return (
    <div className="space-y-6">
      <SettingsTeamCard />
    </div>
  );
};

export default SettingsTeamSection;
